import type { Role } from '@/types/auth';

/** Every role the backend can send, in descending order of privilege. */
export const ALL_ROLES: readonly Role[] = [
  'PLATFORM_ADMIN',
  'ORGANIZATION_ADMIN',
  'SUPERVISOR',
  'OPERATOR',
  'AUDITOR'
];

/** Roles that may manage the team (create/edit/assign users). */
export const MANAGEMENT_ROLES: ReadonlySet<Role> = new Set<Role>([
  'PLATFORM_ADMIN',
  'ORGANIZATION_ADMIN'
]);

/**
 * Roles an organization admin may assign to a team member — strictly below
 * organization admin. Mirrors the backend's UserSerializer.validate_role guard.
 */
export const ASSIGNABLE_ROLES: readonly Role[] = ['SUPERVISOR', 'OPERATOR', 'AUDITOR'];

/** Whether `role` can open and use the team-management screen. */
export const canManageTeam = (role?: Role): boolean => (role ? MANAGEMENT_ROLES.has(role) : false);

/** i18n key for a role's display label; resolve with `t(roleLabelKey(role))`. */
export const roleLabelKey = (role: Role): string => `roles.${role}`;
